import { Component } from '@angular/core';
import { take } from 'rxjs/operators';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
  standalone: false,
})
export class WelcomeComponent {

  constructor(public auth: AuthService) {
  }

  login() {
    this.auth.loginWithRedirect().pipe(take(1)).subscribe();
  }
}
